import { render, staticRenderFns } from "./AddProducts.vue?vue&type=template&id=4fd099b7&"
import script from "./AddProducts.vue?vue&type=script&lang=ts&"
export * from "./AddProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports